function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import apiClient from './utils/api-client';
import { MOBILE_V1 } from './utils/endpoints';
export default (_ref, updateContext) => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints,
    isProduction = _ref.isProduction;
  var getAbsoluteUrl = shared.getAbsoluteUrl,
    getLogger = shared.getLogger;
  var log = getLogger('fe-co-allhomes-api#identity');
  var loadingState = isLoading => ({
    isWatchlistLoading: isLoading,
    isIdentityLoading: isLoading,
    isIdentityLoaded: !isLoading
  });
  var onRefreshIdentity = _ref2 => {
    var token = _ref2.token,
      user = _ref2.user,
      data = _ref2.data;
    log.debug('In onRefreshIdentity', {
      token,
      user,
      data
    });
    updateContext(_objectSpread({
      authData: {
        email: user.email,
        isCasual: user.email == null
      },
      isSignedIn: user.email != null,
      token,
      user,
      watchlist: data.watchlist,
      inspections: data.inspections
    }, loadingState(false)));
  };
  var setLoadingState = state => updateContext(loadingState(state));
  var _endpoints$myahEndpoi = endpoints.myahEndpoint,
    myahEndpoint = _endpoints$myahEndpoi === void 0 ? "".concat(MOBILE_V1, "/myah") : _endpoints$myahEndpoi;
  var endpoint = action => "".concat(getAbsoluteUrl(myahEndpoint), "/").concat(action);
  var _endpoints$identityEn = endpoints.identityEndpoint,
    identityEndpoint = _endpoints$identityEn === void 0 ? endpoint('identity') : _endpoints$identityEn,
    _endpoints$signOutEnd = endpoints.signOutEndpoint,
    signOutEndpoint = _endpoints$signOutEnd === void 0 ? endpoint('logout') : _endpoints$signOutEnd;
  var IDENTITY = getAbsoluteUrl(identityEndpoint);
  var SIGN_OUT = getAbsoluteUrl(signOutEndpoint);

  /* eslint-disable no-param-reassign */
  shared.apiClient = apiClient({
    identityEndpoint: IDENTITY,
    signOutEndpoint: SIGN_OUT,
    isProduction,
    additionalData: ['watchlist', 'inspections'],
    onRefreshIdentity
  });
  shared.setLoadingState = setLoadingState;
  if (typeof window !== 'undefined') {
    shared.setLoadingState(true);
    shared.apiClient.refreshIdentity();
  }
  return _objectSpread({
    authData: {},
    user: {
      type: 'anonymous'
    },
    isSignedIn: false
  }, loadingState(true));
};